import { Capacitor } from '@capacitor/core';

/**
 * Universal cross-app launcher for the WHATIF Android ecosystem.
 * - On Android (Capacitor): Checks if the app is installed. If installed, opens the app.
 *   If not installed, opens the Google Play Store directly to the app install page.
 * - On Web / Desktop: Opens the official website URL in a new browser tab.
 *
 * @param {string} packageName - Android package ID (e.g. 'com.syndicate21.app')
 * @param {string} fallbackWebUrl - Website URL for desktop/browser fallback
 */
export function launchCompanionApp(packageName, fallbackWebUrl) {
    const isNative = Capacitor.isNativePlatform();

    if (isNative) {
        // 1. Try our native Android JavascriptInterface
        if (typeof window !== 'undefined' && window.AndroidAppLauncher && typeof window.AndroidAppLauncher.openAppOrStore === 'function') {
            const handled = window.AndroidAppLauncher.openAppOrStore(packageName);
            if (handled) return;
        }

        // 2. Direct market URI fallback for Android WebViews
        try {
            window.location.href = `market://details?id=${packageName}`;
            return;
        } catch (e) {
            console.warn('[launchCompanionApp] market:// redirect failed:', e);
        }

        // 3. Play Store web fallback
        window.open(`https://play.google.com/store/apps/details?id=${packageName}`, '_system');
        return;
    }

    // On standard web browsers: open official web portal
    if (fallbackWebUrl) {
        window.open(fallbackWebUrl, '_blank', 'noopener,noreferrer');
    }
}
